/**
 * @description: 挂账明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gzm-report">
        <div class="gzm-list" v-show="!showGzmDet&&!showPayLog">
            <div class="row row-margin">
                <label class="list-label-4">挂账时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="gzmTime">
                        <input type="text" class="form-control laydate-icon" v-model="gzmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="gzmEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="gzmShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="gzmBox" data-placeholder="请选择包厢号"></select>
                </div>
                <label class="list-label-3">账单号:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="gzm_bill" placeholder="请输入账单号">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">挂账人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="gzm_user" data-placeholder="请选择操作人"></select>
                </div>
                <label class="list-label-3">担保人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="gzm_admin" data-placeholder="请选择操作人"></select>
                </div>
                <label class="list-label-4">是否还款:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="gzm_status">
                        <option value="0">全部</option>
                        <option value="1">已还款</option>
                        <option value="-1">未还款</option>
                    </select>
                </div>
                <label class="list-label-4">支付方式:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="gzm_paytype"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">还款时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="gzmPaybackTime">
                        <input type="text" class="form-control laydate-icon" v-model="gzmPaybackStartTime" placeholder="请选择日期"> -
                        <input type="text" class="form-control laydate-icon" v-model="gzmPaybackEndTime" placeholder="请选择日期">
                    </div>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getGzmList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getGzmExportSet">导出</button>
                </div>
            </div>
            <!-- <div class="total-txt">
                <div class="total">挂账总额：{{total_amount}}</div>
                <div class="total">还款总额：{{total_payback_amount}}</div>
            </div> -->
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="gzm_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column 
                    :prop="item.value" 
                    :label="item.name" 
                    v-for="item in column_arr" 
                    :width="(item.value=='create_time'||item.value=='payback_time')?'150':'100'">
                </el-table-column>
                <el-table-column label="操作" width="90" fixed="right">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="gzmDet(scope.row.bill_no)">账单详情</span>
                        <span class="text-blue" @click="openPayLog(scope.row.pay_log)" v-if="scope.row.pay_log.length>0">还款记录</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="gzm_list_page"
                :total="gzm_list_total"
                @current-change="getGzmList">
            </el-pagination>
            <div class="check-sum" @click="doSum">查看合计金额</div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="gzmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='gzmExport_allcheck' @click='gzmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in column_arr">
                            <input type="checkbox" v-model='gzmExport_checkModel' :value="item.value">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='gzmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='gzmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="gzm-det" v-show="showGzmDet">
            <billDetail ref="gzm_bill_det" @backBdwPre="showGzmDet = false"></billDetail>
        </div>

        <!-- 还款记录 -->
        <div class="pay-log" v-show="showPayLog">
            <h3 class="pay-log-title">还款记录</h3>
            <el-table :data="pay_log" class="pay-log-table">
                <el-table-column prop="time" label="还款时间"></el-table-column>
                <el-table-column prop="actual_pay" label="还款金额"></el-table-column>
                <el-table-column label="支付方式">  
                    <template slot-scope="scope">
                        <p class="list-p" v-for="item in scope.row.amount">{{item}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
            </el-table>
            <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="backToList">返回</button>
        </div>

        <!-- 合计弹窗 -->
        <div class="sum-pop ele-hide" ref="sum_pop">
            <el-table
                v-loading="pop_loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                style="width:100%"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="sum_table"
                :key="sumTableKey">
                <el-table-column :prop="item.prop" 
                    :label="item.name" 
                    v-for="item in sum_column_arr"
                    :key="item.name"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                showGzmDet: false,
                gzmStartTime: "",
                gzmEndTime: "",
                gzmPaybackStartTime: "",
                gzmPaybackEndTime: "",
                gzm_bill: '',
                gzm_list: [],
				gzm_list_page: 1,
                gzm_list_total: 0,
                gzmExport_allcheck: false,
                c_gzmExport_allcheck: false,
                gzmExport_checkModel: [],
                gzmExport_checkData: [],
                gzmExport_type: 1,
                showPayLog: false,
                pay_log: [], // 还款记录
                total_amount: 0,
                total_payback_amount: 0,
                column_arr: [],
                sum_table: [],
                sum_column_arr: [],
                pop_loading: false,
                sumTableKey: Math.random(),
                isSuming: false,
            }
        },
        components: {
            "billDetail": billDetail
        },
        watch: {
            gzmExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.gzmExport_checkModel.length >= this.gzmExport_checkData.length) {
                        this.gzmExport_allcheck = true;
                        this.c_gzmExport_allcheck = true;
                    } else {
                        this.gzmExport_allcheck = false;
                        this.c_gzmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            this.gzmStartTime = moment().format('YYYY-MM-DD 08:00');
            this.gzmEndTime = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput(); // 门店
            $(this.$refs.gzm_status).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.gzmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.gzmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.gzmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.gzmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.gzmTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.gzmStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.gzmEndTime = end.format('YYYY-MM-DD 08:00');
                });

                $(_this.$refs.gzmPaybackTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.gzmPaybackStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.gzmPaybackEndTime = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.gzmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 挂账人、担保人
                                _this.getAdminData(e.params.data.id);
                                _this.getPaytypeData(e.params.data.id);
                                if(e.params.data.text == "全部") {
                                    // 包厢号
                                    $(_this.$refs.gzmBox).val('').trigger('change');
                                    $(_this.$refs.gzmBox).prop('disabled', true);
                                    return;
                                }
                                // 包厢号
                                $(_this.$refs.gzmBox).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.gzmShop).val(data.response.result[1].id).trigger('change');
                            // 包厢号
                            $(_this.$refs.gzmBox).prop('disabled', false);
                            _this.getRoomdata(data.response.result[1].id);
                            // 挂账人、担保人
                            _this.getAdminData(data.response.result[1].id);
                            _this.getPaytypeData(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.getGzmList(1)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.gzmBox).html("");
                            $(_this.$refs.gzmBox).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取挂账人、担保人
            getAdminData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.gzm_user).html("");
                            $(_this.$refs.gzm_user).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                            $(_this.$refs.gzm_admin).html("");
                            $(_this.$refs.gzm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取支付方式
            getPaytypeData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "api_type": 'hanging_log'
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let paytype = [],
                                arr = [{id: '0', text: '全部'}];
                            for(let [key, value] of Object.entries(data.response.data)) {
                                arr.push({id: key, text: value});
                                paytype.push({id: key, name: value});
                            }
                            $(_this.$refs.gzm_paytype).html("");
                            $(_this.$refs.gzm_paytype).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            getGzmList(page) {
				const _this = this;

                _this.loading = true
                _this.gzm_list_page = page
				Vue.axios.post('FinanceReport2/getHangingLogList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.gzmStartTime,
                            "end_time": _this.gzmEndTime,
                            "shop_id": $(_this.$refs.gzmShop).val(),
                            "room_id": $.trim($(_this.$refs.gzmBox).val()),
                            "bill_no": _this.gzm_bill,
                            "hanging_admin_id": $.trim($(_this.$refs.gzm_user).val()),
                            "bondsman_admin_id": $.trim($(_this.$refs.gzm_admin).val()),
                            "status": $(_this.$refs.gzm_status).val(),
                            "pay_platform": $(_this.$refs.gzm_paytype).val(),
                            "payback_start_time": _this.gzmPaybackStartTime,
                            "payback_end_time": _this.gzmPaybackEndTime,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.gzm_list_total = Number(res.data.response.count)
                            _this.total_amount = res.data.response.total_amount
                            _this.total_payback_amount = res.data.response.total_payback_amount
                            _this.column_arr = []
                            _this.gzmExport_checkData = []
                            for(let i in res.data.response.column_arr) {
                                _this.column_arr.push({
                                    value: i,
                                    name: res.data.response.column_arr[i]
                                })
                                _this.gzmExport_checkData.push(i)
                            }
						}
						_this.gzm_list = res.data.response.data
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 获取导出设置
            getGzmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/hangingLogListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.gzmExport_checkModel = data.response.result.export_fields;
                                _this.gzmExport_type = data.response.result.export_type;
                            } else {
                                _this.gzmExport_checkModel = _this.gzmExport_checkData;
                                _this.gzmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.gzmExport_alert)
                }, function() {
                    _this.exportGzmList();
                });
            },
            // 导出字段全选
            gzmExportCheckedAll: function() {
                let _this = this;
                _this.gzmExport_allcheck = _this.c_gzmExport_allcheck;
                if(!_this.gzmExport_allcheck) { // 实现全选
                    _this.gzmExport_checkModel = [];
                    _this.gzmExport_checkData.forEach(function(item) {
                        _this.gzmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.gzmExport_checkModel = [];
                }
            },
            // 导出
            exportGzmList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.gzmExport_checkModel);

                window.location.href = Vue.ctUrl + "FinanceReport2/hangingLogListExport?" +
                    "start_time=" + _this.gzmStartTime +
                    "&end_time=" + _this.gzmEndTime +
                    "&shop_id=" + $(_this.$refs.gzmShop).val() +
                    "&room_id=" + $.trim($(_this.$refs.gzmBox).val()) +
                    "&bill_no=" + _this.gzm_bill +
                    "&hanging_admin_id=" + $.trim($(_this.$refs.gzm_user).val()) +
                    "&bondsman_admin_id=" + $.trim($(_this.$refs.gzm_admin).val()) +
                    "&status=" + $(_this.$refs.gzm_status).val() +
                    "&pay_platform=" + $(_this.$refs.gzm_paytype).val() +
                    "&payback_start_time=" + _this.gzmPaybackStartTime +
                    "&payback_end_time=" + _this.gzmPaybackEndTime +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.gzmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 查看账单
            gzmDet(bill_no) {
                this.$refs.gzm_bill_det.getBdwDetail(bill_no)
                this.showGzmDet = true
            },


            // 打开付款详情
            openPayLog(pay_log) {
                this.pay_log = pay_log
                this.showPayLog = true
            },

            backToList() {
                this.showPayLog = false
            },

            // 查看合计金额
            doSum() {
                if(this.isSuming) {
                    return;
                }
                this.isSuming = true;
               
                const _this = this;
                _this.pop_loading = true;
                Vue.axios.post('FinanceReport2/getHangingLogSumAmount', {})
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.sum_column_arr = []
                        _this.sum_table = []
                        for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                _this.sum_column_arr.push({ prop: key, name: value });
                            }
                        _this.sum_table.push(res.data.response.result.data);
                        _this.sumTableKey = Math.random();

                        layer.confirm('', {
                            skin: 'public-alert-skin',
                            type: 1,
                            btn: [], // 按钮
                            title: ['合计', true],
                            area: ['1000px', ''], // 宽高
                            content: $(_this.$refs.sum_pop),
                            offset: '260px',
                        });
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                    _this.pop_loading = false;
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    this.isSuming = false;
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .gzm-list {
        .el-table__fixed {
            // less 转义
            height: calc(~'100% - 30px') !important;
        }
        .el-table__fixed-right {
            // less 转义
            height: calc(~'100% - 30px') !important;
        }
        .total-txt {
            display: flex;
            flex-direction: row;
            align-items: center;
            .total {
                margin-right: 40px;
            }
        }
    }

    .pay-log {
        .pay-log-title {
            margin: 10px 0 20px 30px;
        }
        .pay-log-table {
            width: 900px;
            margin-left: 30px;
            margin-bottom: 50px;
        }
        .list-p {
            margin-bottom: 5px;
        }
        .btn-border-gray {
            margin-left: 30px;
        }
    }

    .check-sum {
        margin-top: -30px;
        margin-left: 20px;
        color: #409EFF;
        cursor: pointer;
    }

</style>